import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import moment from "moment";
import "moment/locale/es";
import AutocompleteComponent from "./AutocompleteComponent";
import { saveFamily } from "../../actions/emd_actions";
import CrudButtons from "../../consts/CrudButtons";
import Loading from "../Loading";

moment.locale("es");

const parental = [
  { id: 1, es: "Padre", en: "Father" },
  { id: 2, es: "Madre", en: "Mother" },
  { id: 3, es: "Hermano", en: "Brother" },
  { id: 4, es: "Hermana", en: "Sister" },
  { id: 5, es: "Abuela Materna", en: "Maternal Grandmother" },
  { id: 6, es: "Abuela Paterna", en: "Paternal Grandmother" },
  { id: 7, es: "Abuelo Materno", en: "Maternal Grandfather" },
  { id: 8, es: "Abuelo Paterno", en: "Paternal Grandfather" }
];

const validate = values => {
  const errors = {};
  if (!values.date) {
    errors.date = "Obligatorio";
  } else if (
    !/[0-9]{1,8}/i.test(values.date) ||
    values.date < 0 ||
    values.date >= 118
  ) {
    errors.date = "Edad no válida";
  }

  return errors;
};

const renderField = ({
  input,
  name,
  className,
  type,
  max,
  meta: { touched, error }
}) => {
  return (
    <div>
      <div>
        <input className={className} {...input} type={type} max={max} />
        {touched && error && <span>{error}</span>}
      </div>
    </div>
  );
};

class FamilyHistories extends Component {
  state = {
    error: false,
    count: 0,
    form: false
  };

  increment() {
    this.setState({ count: this.state.count + 3 });
  }

  decrement() {
    this.setState({ count: this.state.count - 3 });
  }

  render() {
    const { data, handleSubmit, user, dispatch, loading, reset } = this.props;

    const onFormSubmit = data => {
      if (!data.member || !data.date) {
        this.setState({ error: "Debe completar el formulario" });
      } else {
        this.setState({ error: false });
        console.log("data.is_death", data);
        let valueIsDeath = data.is_death === "true" ? true : false;
        console.log("data.is_death", data);
        console.log("valueIsDeath", valueIsDeath);
        let values = {
          user: user._id,
          date: data.date,
          is_death: valueIsDeath,
          familyRelationship: parental[parseInt(data.member) - 1]
        };

        dispatch(saveFamily(values));
        this.setState({ form: false });
        reset("FamilyHistories");
      }
    };

    let finit = Math.round(data && data.length / 3);
    /*  if (!Number.isInteger(bloodPressure.length / 3)) finit = finit + 1;*/

    const createTable = value => {
      let table = [];

      for (let i = 0; i < value; i++) {
        table.push(
          <li className="page-item" key={i}>
            <button
              style={{
                color: i * 3 === this.state.count ? "#ffffff" : "#19769F",
                backgroundColor: i * 3 === this.state.count ? "#19769F" : null
              }}
              className="page-link"
              onClick={() => this.setState({ count: i * 3 })}
            >
              {i + 1}
            </button>
          </li>
        );
      }
      return table;
    };

    return (
      <div className="col-md-12">
        <div className="card full-height">
          <div className="card-header">
            <div className="d-flex align-items-center">
              <div className="card-title">Antecedentes Familiares</div>
              <div className="ml-auto">
                <button
                  onClick={() => {
                    this.setState({ form: !this.state.form });
                    reset("FamilyHistories");
                  }}
                  className="btn btn-icon btn-round btn-primary text-center"
                >
                  <i className="fas fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            {this.state.form && (
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Descripción Clínica</label>
                    <AutocompleteComponent />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Miembro Familiar</label>

                    <Field
                      name={"member"}
                      component={"select"}
                      className={"form-control"}
                    >
                      <option value="" disabled>
                        Seleccione
                      </option>
                      {parental.map((item, i) => (
                        <option value={item.id} key={i}>
                          {item.es}
                        </option>
                      ))}
                    </Field>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>¿Qué edad tenía?</label>
                    <Field
                      name="date"
                      className="form-control"
                      component={renderField}
                      type="number"
                      //max={moment().format("YYYY-MM-DD")}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>¿Status de vida?</label>
                    <div className="row">
                      <div className="col-md-4">
                        <label className="form-radio-label ml-4">
                          Vivo
                          <Field
                            className="form-radio-input"
                            name="is_death"
                            component={renderField}
                            type="radio"
                            value={"false"}
                          />
                        </label>
                      </div>
                      <div className="col-md-4">
                        <label className="form-radio-label ml-4">
                          Muerto
                          <Field
                            className="form-radio-input"
                            name="is_death"
                            component={renderField}
                            type="radio"
                            value={"true"}
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="form-group">
                    <label>{/*Acción*/}</label>

                    <button
                      onClick={handleSubmit(onFormSubmit)}
                      className="btn btn-icon btn-round btn-primary text-center"
                    >
                      <i className="fas fa-check"></i>
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div
              className="row"
              style={{
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center"
              }}
            >
              {this.state.error && <span>{this.state.error}</span>}
            </div>

            {loading && <Loading />}

            {!loading && (
              <>
                <div className="separator-dashed"></div>
                {data &&
                  data
                    .sort(function(a, b) {
                      a = new Date(a.created_at);
                      b = new Date(b.created_at);
                      if (a > b) return -1;
                      if (a < b) return 1;
                      return 0;
                    })
                    .slice(this.state.count, this.state.count + 3)
                    .map((item, i) => {
                      console.log("dataaaa", item);
                      return (
                        <div key={i}>
                          <div className="d-flex">
                            <div className="flex-1 ml-3 pt-1">
                              <h6
                                className="text-uppercase fw-bold mb-1"
                                style={{ fontSize: ".65rem" }}
                              >
                                Descripción Clínica
                              </h6>
                              <span className="text-muted">
                                {item.MedicalHistory.history.name.es}
                              </span>
                              <span className="text-warning pl-3"></span>
                            </div>
                            <div className="flex-1 ml-3 pt-1">
                              <h6
                                className="text-uppercase fw-bold mb-1"
                                style={{ fontSize: ".65rem" }}
                              >
                                Miembro Familiar
                              </h6>
                              <span className="text-muted">
                                {item.familyRelationship.es}
                              </span>
                            </div>
                            <div className="flex-1 ml-3 pt-1">
                              <h6
                                className="text-uppercase fw-bold mb-1"
                                style={{ fontSize: ".65rem" }}
                              >
                                Fecha Aproximada o Edad
                              </h6>
                              <span className="text-muted">
                                {item.MedicalHistory.date.length > 3
                                  ? moment(item.MedicalHistory.date).format(
                                      "MM-YYYY"
                                    )
                                  : item.MedicalHistory.date}
                              </span>
                            </div>
                            <div className="flex-1 ml-3 pt-1">
                              <h6
                                className="text-uppercase fw-bold mb-1"
                                style={{ fontSize: ".65rem" }}
                              >
                                Status de vida
                              </h6>
                              <span className="text-muted">
                                {item.is_death ? "Muerto" : "Vivo"}
                              </span>
                            </div>
                            <CrudButtons
                              data={item}
                              user_id={user._id}
                              clickHandler={"family"}
                            />
                          </div>

                          <div className="separator-dashed"></div>
                        </div>
                      );
                    })}
                <br />
                <div className="align-content-center justify-content-center">
                  <ul className="pagination justify-content-center">
                    <li className="page-item">
                      {this.state.count > 0 ? (
                        <button
                          onClick={this.decrement.bind(this)}
                          className="page-link"
                          style={{ color: "#19769F" }}
                        >
                          <i className="fas fa-angle-double-left"></i>
                        </button>
                      ) : (
                        false
                      )}
                    </li>
                    {createTable(finit)}
                    {this.state.count + 3 < finit * 3 ? (
                      <li className="page-item">
                        <button
                          onClick={this.increment.bind(this)}
                          className="page-link"
                          style={{ color: "#19769F" }}
                        >
                          <i className="fas fa-angle-double-right"></i>
                        </button>
                      </li>
                    ) : null}
                  </ul>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.reducer.loadingFamily
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ saveFamily }, dispatch);

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: "FamilyHistories",
    validate
  })
)(FamilyHistories);
